'use strict';

app.filter('duration', function () {
  return function (value) {
    if (!value || value < 0) {
      return '0 min';
    }
    var h = Math.floor(value / 60);
    var m = value % 60;
    var hs = (h === 0) ? '' : (h === 1) ? '1 hour' : h + ' hours';
    var ms = (m === 0) ? '' : ' ' + m + ' mins';
    return (hs + ms);
  };
});
